import { supabase } from "../supabaseClient";

export async function prepareSessionForProfile(profileId) {
  try {
    // Get the current session to include the auth token
    const {
      data: { session },
      error: sessionError,
    } = await supabase.auth.getSession();

    if (sessionError) {
      console.error(
        "[prepareSessionForProfile] Error getting session:",
        sessionError
      );
      throw sessionError;
    }

    if (!session?.access_token) {
      throw new Error("No authentication token available");
    }

    // Call the Edge Function
    const { data, error } = await supabase.functions.invoke(
      "ensure_open_session",
      {
        body: { profile_id: profileId },
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
      }
    );

    if (error) {
      console.error("[prepareSessionForProfile] Edge Function error:", error);
      throw error;
    }

    if (!data?.session_id) {
      throw new Error("Edge Function did not return a session_id");
    }

    return data.session_id;
  } catch (error) {
    console.error("[prepareSessionForProfile] Error:", error);
    throw error;
  }
}

// Utility function to get the current open session for a profile
export async function getCurrentOpenSession(profileId) {
  try {
    const { data: sessions, error } = await supabase
      .from("sessions")
      .select("session_id")
      .eq("profile_id", profileId)
      .is("end_date", null)
      .limit(1);

    if (error) {
      console.error(
        "[getCurrentOpenSession] Error fetching open session:",
        error
      );
      throw error;
    }

    return sessions && sessions.length > 0 ? sessions[0] : null;
  } catch (error) {
    console.error("[getCurrentOpenSession] Error:", error);
    throw error;
  }
}
